import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Button, MenuItem, Dialog, DialogActions, DialogContent,
  FormControlLabel, FormControl, Select, FormLabel, Radio, RadioGroup,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Constants from '../../common/constants';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
}));

const Posts = ({ onClose, onComplete, displayText }) => {
  const classes = useStyles();
  const [postType, setPostType] = useState(Constants.PostType.Promo);
  const [promoType, setPromoType] = useState(`${Constants.PromoType.Deals}`);
  const [showSelectPromo, setShowSelectPromo] = useState(true);

  const handleChange = (event) => {
    setPromoType(event.target.value);
  };

  const handlePostType = (event) => {
    setPostType(event.target.value);
    if (event.target.value === Constants.PostType.Promo) {
      setShowSelectPromo(true);
      setPromoType(Constants.PromoType.Coupon);
    } else {
      setShowSelectPromo(false);
      setPromoType('');
    }
  };

  const cancelClicked = () => {
    try {
      onClose();
    } catch (error) {
    }
  };

  const addClicked = () => {
    try {
      onComplete({ postType, promoType });
    } catch (error) {
    }
  };

  return (
    <>
      <div>
        <Dialog
          fullWidth
          maxWidth="sm"
          open
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <Typography style={{ wordWrap: 'break-word' }}>
              {displayText ? `"` : ''}
              {displayText}
              {displayText ? `"` : ''}
              {' '}
            </Typography>
            <div style={{ marginTop: 15 }}>
              <Typography variant="h5">Select</Typography>
              <FormLabel component="legend" style={{ marginTop: 15 }}>Post Type</FormLabel>
              <RadioGroup
                row
                aria-label="postType"
                name="postType"
                value={postType}
                onChange={(e) => handlePostType(e)}
              >
                <FormControlLabel
                  value={Constants.PostType.Article}
                  control={<Radio color="primary" />}
                  label={Constants.PostType.Article}
                />
                <FormControlLabel
                  value={Constants.PostType.Promo}
                  control={<Radio color="primary" />}
                  label={Constants.PostType.Promo}
                />
                {/* <FormControlLabel
                  value={Constants.PostType.Others}
                  control={<Radio color="primary" />}
                  label={Constants.PostType.Others}
                /> */}
              </RadioGroup>

              {showSelectPromo
                ? (
                  <div>
                    <FormLabel component="legend">Promo Type</FormLabel>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={promoType}
                        onChange={handleChange}
                        label="promoType"
                      >
                        <MenuItem value={Constants.PromoType.Coupon}>{Constants.PromoType.Coupon}</MenuItem>
                        <MenuItem value={Constants.PromoType.CreditCard}>{Constants.PromoType.CreditCard}</MenuItem>
                        <MenuItem value={Constants.PromoType.Deals}>{Constants.PromoType.Deals}</MenuItem>
                        <MenuItem value={Constants.PromoType.Events}>{Constants.PromoType.Events}</MenuItem>
                        <MenuItem value={Constants.PromoType.LuckyDraw}>{Constants.PromoType.LuckyDraw}</MenuItem>
                        <MenuItem value={Constants.PromoType.NewLaunch}>{Constants.PromoType.NewLaunch}</MenuItem>
                        <MenuItem value={Constants.PromoType.PromoCode}>{Constants.PromoType.PromoCode}</MenuItem>
                        <MenuItem value={Constants.PromoType.Vouchers}>{Constants.PromoType.Vouchers}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                )
                : ''}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => cancelClicked()} color="primary">
              Cancel
            </Button>
            <Button onClick={() => addClicked()} color="primary">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default connect(null, { })(Posts);
